export default __webpack_public_path__ + "static/firewood-stack-e0c3c8f06e2e4bd57fcc487993f73b88.jpg";